import thanq from "../api/thanq";

class ConfigData {
    isLoaded;
    options;
    shareMessage;
    reviewPoints;
    id;

    constructor() {
        this.isLoaded = false;
        this.options = {
            Waiter: "utensils",
            Delivery: "truck",
            Driver: "taxi",
            Security: "shield-halved",
            Bartender: "wine-glass",
            Carpenter: "gavel",
            "Hair Stylist": "scissors",
            "Spa Therapist": "spa",
            Other: "asterisk",
        };
        this.shareMessage = ["", ""];
        this.reviewPoints = 0;
        this.id = null;
    }

    loadConfig = async () => {
        if (this.isLoaded) return;
        try {
            const { data: config } = await thanq.get("/config");
            this.isLoaded = true;
            if (config?.options && Object.keys(config.options).length) {
                const newOptions = {};
                Object.entries(config.options)
                    // sort by label alphabetically but if label is Other, put it at the end
                    .sort(([_keyA, a], [_keyB, b]) => {
                        if (a.label === "Other") return 1;
                        if (b.label === "Other") return -1;
                        return a.label.localeCompare(b.label);
                    })
                    .forEach(([_, item]) => {
                        newOptions[item.label] = item.icon;
                    });
                this.options = newOptions;
            }
            if (config?.share) {
                this.shareMessage = [config.share["SHARE_TEXT_1"], config.share["SHARE_TEXT_2"]];
            }
            if (config?.review_points !== undefined) {
                this.reviewPoints = config.review_points;
            }
            this.id = config.id;
            return;
        } catch (e) {
            // handle error, optionally log
            this.isLoaded = false;
        }
    };

    getConfig = () => {
        return { options: this.options, shareMessage: this.shareMessage, reviewPoints: this.reviewPoints, id: this.id };
    };

    updateConfig = async (configId, data) => {
        try {
            const res = await thanq.put(`/admin/config/${configId}`, {
                ...data,
            });
            if (!res) {
                console.error("some error occured");
            }
        } catch (err) {
            console.error(err);
        }
    };
}

export default ConfigData;
